/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { STYLES_FLEX_COLUMN_LAYOUT } from '@gh/core-ui';

@Component({
  standalone: false,
  selector: 'gh-contact-details-customer-relative',
  templateUrl: 'contact-details-customer-relative.component.html',
  styles: [STYLES_FLEX_COLUMN_LAYOUT],
})
export class ContactDetailsCustomerRelativeComponent {
  @Input() nameControl: FormControl;
  @Input() dateOfBirthControl: FormControl;
  @Input() nameLabel: string;
  @Input() dateOfBirthLabel: string;
}
